import { MDText } from 'i18n-react';

import { Modal } from '@motorway/motorway-component-library';
import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import {
	triggerCancelOfferOrBidModalClosedEvent,
	triggerKeepOfferOrBidButtonClickedEvent,
} from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';

import type { GetSaleType } from '../BiddingSectionCTAStateController/getSaleType';

import cancelModalTexts from './CancelModal.texts';

import styles from './CancelModal.module.scss';

interface CancelModalProps {
	bidOrOfferAmountDisplayValue: string;
	dismissModal: () => void;
	isCancellationInProgress: boolean;
	onCancel: () => void;
	purchaseTypeLabel: string;
	saleType: GetSaleType;
}

const LocalT = new MDText(cancelModalTexts);

export const CancelModal: React.FC<CancelModalProps> = ({
	bidOrOfferAmountDisplayValue,
	dismissModal,
	isCancellationInProgress,
	onCancel,
	purchaseTypeLabel,
	saleType,
}) => {
	const handleDismissModal = () => {
		triggerCancelOfferOrBidModalClosedEvent(purchaseTypeLabel);
		dismissModal();
	};

	const handleKeepIt = () => {
		triggerKeepOfferOrBidButtonClickedEvent(purchaseTypeLabel);
		dismissModal();
	};

	return (
		<Modal centered dark dismissModal={handleDismissModal} size="small">
			<div className={styles.container}>
				<h1 className={styles.title}>{LocalT.translate(`title.${saleType}`)}</h1>
				<p className={styles.text}>
					{LocalT.translate(`confirmation.message.${saleType}`, {
						amount: bidOrOfferAmountDisplayValue,
					})}
				</p>
				<div className={styles.buttonContainer}>
					<Button
						{...applyCypressData(cypressIds.buttons.cancelModal)}
						disabled={isCancellationInProgress}
						label={LocalT.translate(`confirmation.accept.${saleType}`)}
						loading={isCancellationInProgress}
						onClick={onCancel}
						variant="primary"
					/>
					<Button
						{...applyCypressData(cypressIds.buttons.cancelModalKeep)}
						className={styles.button}
						label={LocalT.translate(`confirmation.deny`)}
						onClick={handleKeepIt}
						variant="secondary"
					/>
				</div>
			</div>
		</Modal>
	);
};
